<template>
  <div style="overflow-x: hidden">
    <h1 style="width: 0; height: 0; opacity: 0; visibility: hidden; overflow: hidden; margin: 0">
      {{ $t("common.news") }}
    </h1>

    <section class="breadcrumb_nav">
      <div class="breadcrumb_nav_img relative">
        <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/articles/image_1668499027_21.jpg" alt="img" />
        <h2 class="breadcrumb_nav_title text-center hidden-xs">
          {{ $t("common.news") }}
        </h2>
      </div>

      <div class="breadcrumb_nav_wrap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb_nav_box">
                <ul class="breadcrumb_nav_list">
                  <li>
                    <a href="/">{{ $t("common.home") }}</a>
                  </li>

                  <li>
                    <i class="fa fa-angle-double-right"></i>
                    <span> {{ $t("common.news") }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 页面样式 -->
    <link rel="stylesheet" href="/css/articles-1.css" />

    <main>
      <section class="articles_list">
        <div class="container">
          <div class="row">
            <div class="col-lg-9 col-md-8 col-sm-12 col-xs-12 section-main pull-right">
              <div v-for="(item, index) in list" :key="index" class="thumbnail">
                <div class="row">
                  <div class="col-sm-6">
                    <a :href="'/Articles/' + item.trainingId" :title="item.title">
                      <img :alt="item.title" :src="item.cover" width="600" height="400" />
                    </a>
                  </div>
                  <div class="col-sm-6">
                    <div class="caption">
                      <h3>
                        <a :href="'/Articles/' + item.trainingId" :title="item.title">{{ item.title }}</a>
                      </h3>
                      <div class="mate">
                        <span><i class="fa fa-clock-o"></i> {{ item.createTime }}</span>
                      </div>
                      <div class="desc">
                        {{ item.description }}
                      </div>
                    </div>
                    <div class="button-box row">
                      <a class="btn btn-primary col" style="font-size: 16px; width: auto; padding: 8px 24px" :href="'/Articles/' + item.trainingId">{{ $t("common.viewMore") }} →</a>
                    </div>
                  </div>
                </div>
              </div>

              <nav v-if="total > page.per_page" aria-label="Page navigation" style="text-align: right; margin-top: 30px">
                  <ul class="pagination">
                    <li :class="{ disabled: page.page === 1 }" key="a">
                      <a href="javascript:;" aria-label="Previous" @click="page.page !== 1 && page.page++">
                        <span aria-hidden="true">&laquo;</span>
                      </a>
                    </li>
                    <li v-for="(item, i) in Math.ceil(total / page.per_page)" :key="i" :class="{ active: page.page === item }">
                      <a href="javascript:;" @click="page.page = item">{{ item }}</a>
                    </li>
                    <li :class="{ disabled: page.page === Math.ceil(total / page.per_page) }" key="b">
                      <a href="javascript:;" aria-label="Next" @click="page.page !== Math.ceil(total / page.per_page) && page.page++">
                        <span aria-hidden="true">&raquo;</span>
                      </a>
                    </li>
                  </ul>
                </nav>

            </div>
            <div class="col-lg-3 col-md-4 col-sm-12 col-xs-12">
              <aside>
                <!-- 侧边搜索-->
                <div class="aside-search">
                  <div>
                    <div class="input-group">
                      <input types="text" class="form-control" :placeholder="$t('common.search') + '...'" required name="keyword" v-model="title"/>
                      <span class="input-group-btn">
                        <button class="btn btn-default btn-primary" types="submit" @click="()=>{page.page=1;getList()}">{{ $t("common.search") }} →</button>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- /侧边搜索 -->

                <div class="mb-3"></div>

                <!-- 侧边导航菜单 -->

                <div class="aside-munu">
                  <ul id="asideMenu" class="list-group treemenu treemenu-root">
                    <!-- <li class="list-group-item tree-empty"><span class="toggler"></span><a href="/Articles">{{$t('common.industry')}}{{$t('common.news')}}</a></li> -->
                    <li class="list-group-item tree-empty">
                      <span class="toggler"></span><a  @click="types=2">{{ $t("common.company") }}{{ $t("common.news") }}</a>
                    </li>
                    <li class="list-group-item tree-empty">
                      <span class="toggler"></span><a @click="types=1">{{ $t("common.industry") }}{{ $t("common.news") }}</a>
                    </li>
                  </ul>
                </div>
                <!-- /侧边导航菜单 -->

                <div class="mb-3"></div>
              </aside>
              <div class="section-margin-2x"></div>
            </div>
          </div>
        </div>
      </section>

      <div class="section-margin-1x">
        <div class="container">
          <hr />
        </div>
      </div>

      <!-- <section class="recommend-section">
        <div class="container">
          <div class="section-head">
            <h2>{{ $t("common.mostViewed") }}</h2>
          </div>
          <div
            class="RecommendProducts owl-carousel owl-theme recommend-carousel"
          >
            <div v-for="(item, index) in list" :key="index" class="thumbnail">
              <a :href="'/Articles/' + item.id" :title="item.title"
                ><img
                  :alt="item.title"
                  src="//v4-upload.goalsites.com/916/image_1681710506_%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20230411091737.jpg?imageView2/1/w/343/h/229/format/webp"
                  width="600"
                  height="400"
              /></a>
              <div class="caption">
                <h3>
                  <a :href="'/Articles/' + item.id" :title="item.title">{{
                    item.title
                  }}</a>
                </h3>
                <div class="mate">
                  <span
                    ><i class="fa fa-clock-o"></i>{{ item.createTime }}</span
                  >
                </div>
                <hr />
                <div class="desc">
                  电动自行车展-2023 时间：2023-04-11-04-14
                  地址：香港亚洲国际博览馆 展位号：2j01
                  4月11日至4月14日，MIDONKEY电动自行车
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> -->

      <div class="section-margin-2x"></div>
    </main>
  </div>
</template>
<script setup>
import { watch, reactive, onMounted, ref } from "vue"
import i18n from "@/i18n"
import axios from "axios"
import { pagepageIndependentArticalInfo } from "@/utils/api"
const list = ref([])
const total = ref(0)
const page = reactive({ page: 1, per_page: 5 })
const types = ref(2)
const title = ref('')
const getList = () => {
  // axios({
  //   url: `/api/articles-${i18n.locale}.json`,
  //   method: "get"
  // }).then((res) => {
  //   list.value = res.data
  // })

  pagepageIndependentArticalInfo({ page, type: types.value, title: title.value, language: i18n.locale , state:1}).then((res) => {
    list.value = res.data.list
    total.value = res.data.total
  })

}
import router from "@/router"
const route = router.currentRoute
 const articalType= ref()
 articalType.value=route.query.type
watch(
  () => i18n.locale,
  (currentValue, prevValue) => {
    getList()
  }
)
watch( 
  () => route.query.type,
  (newValue, oldValue)=>{
    if(newValue==1){
      types.value=1
    }else if(newValue==2){
      types.value=2
    }
    getList()    
  } ,
  { immediate: true }
)
watch([page, types], () => {
  getList()
})

onMounted(() => {
  getList()
  $(function () {
    $("#asideMenu").treemenu({
      delay: 200,
      closeOther: !0,
      openActive: !0
    }),
      $(".RecommendProducts").length &&
        $(".RecommendProducts").owlCarousel({
          items: 1,
          loop: !0,
          nav: !0,
          navText: ['<i class="fa fa-angle-left">', '<i class="fa fa-angle-right">'],
          dots: !1,
          autoplay: !0,
          autoplayTimeout: 6e3,
          autoplayHoverPause: !0,
          lazyLoad: !0,
          margin: 15,
          rtl: "rtl" === document.querySelector("html").getAttribute("dir"),
          responsive: {
            480: {
              items: 1
            },
            768: {
              items: 2
            },
            1024: {
              items: 3
            }
          }
        })
  })
})
</script>
<style scoped>
main .aside-product .media .media-left a.media-img {
  display: block;
  padding-bottom: 100%;
  overflow: hidden;
  position: relative;
}

main .aside-product .media .media-left a.media-img img {
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

main .aside-product .media .media-heading {
  margin: 0;
  color: #333;
  line-height: 20px;
  font-size: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  font-weight: 500;
}

main .aside-search .input-group .input-group-btn button {
  outline: none;
}

.aside-munu .list-group {
  margin-left: 0;
}

.articles_list {
  padding: 50px 0 0;
}

main .btn-primary,
main .btn-primary.focus,
main .btn-primary:focus {
  background-color: var(--main-theme-color);
  border-color: var(--main-theme-color);
}

main .section-head h2 {
  margin-bottom: 1.2em;
  margin-top: 0;
  font-size: 25px;
}

main .section-head h2:after {
  background-color: var(--main-theme-color);
}

main .thumbnail .mate {
  font-size: 13px;
}

main .thumbnail .mate .fa {
  color: var(--main-theme-color);
}

main .btn-primary:hover,
main .btn-primary:active {
  background-color: var(--sub-theme-color);
  border-color: var(--sub-theme-color);
  color: #fff !important;
}

main .aside-munu .list-group-item .toggler::before {
  margin-top: 0em;
}

main .aside-munu .list-group-item.active > a,
main .aside-munu .list-group-item.tree-opened > a {
  color: var(--main-theme-color) !important;
}

main .section-main .thumbnail .desc {
  margin: 0.8em 0;
  height: 92px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  font-size: 16px;
  line-height: 23px;
}

main .thumbnail .caption a {
  font-size: 20px;
  line-height: 24px;
  height: 48px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

main .recommend-section .thumbnail p {
  height: 63px;
}

main .recommend-section .thumbnail .desc {
  font-size: 16px;
  line-height: 23px;
  color: #666;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  height: 69px;
}

[dir="rtl"] main .aside-munu .list-group-item a {
  padding-right: 3em;
  padding-left: 0;
}

[dir="rtl"] main .section-head h2:after {
  right: 0;
  left: auto;
}

.alert-info {
  background-color: var(--main-theme-color);
  border-color: var(--main-theme-color);
  color: #fff;
}

@media only screen and (max-width: 767px) {
  main .thumbnail .button-box.row .btn {
    font-size: 14px;
  }

  main .section-margin-1x {
    margin: 8px 0px 14px;
  }

  .articles_list {
    padding: 40px 0 0;
  }

  main .section-margin-2x {
    margin: 30px;
  }

  main hr {
    margin: 0.4em 0;
  }

  main .section-head h2 {
    font-size: 21px;
  }
}
</style>
